<template>
  <div class='datetime'>
    <b-row>
      <b-col :xs="isDesktop ? 5 : 12" :lg="isDesktop ? 5 : 12" class="clock">
        <center>{{ dislayDateTime }}</center>
        <div class="container">
          <center>
            <div class="grid-container">
              <div><font-awesome-icon class="icon" @click="setHour(true)" :icon="faChevronUp" /></div>
              <div></div>
              <div><font-awesome-icon class="icon" @click="setMinute(true)" :icon="faChevronUp" /></div>
              <div><div class="time-digit">{{ hour.toString().padStart(2, "0") }}</div></div>
              <div><div class="time-digit">:</div></div>
              <div><div class="time-digit">{{ minute.toString().padStart(2, "0") }}</div></div>
              <div><font-awesome-icon class="icon" @click="setHour(false)" :icon="faChevronDown" /></div>
              <div></div>
              <div><font-awesome-icon class="icon" @click="setMinute(false)" :icon="faChevronDown" /></div>
            </div>
          </center>
        </div>
      </b-col>

      <b-col :xs="isDesktop ? 5 : 12" :lg="isDesktop ? 5 : 12">
        <center>
          <calendar
            :date="moment(date, DATE_FORMAT).toISOString() || undefined"
            @dateChange="setDate"
            :yearRange="[moment().subtract(100, 'year').year(), moment().subtract(15, 'year').year()]"
          />
        </center>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Calendar from '@/components/Calendar';
import { DATE_TIME_FORMAT, DATE_FORMAT, DISPLAY_DATE_TIME_FORMAT } from '@/consts';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import moment from 'moment';

const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'DateTime',
  components: {
    Calendar,
    FontAwesomeIcon,
  },
  props: {
    value: String
  },
  setup(props, { emit }) {
    const { isDesktop } = useAppState(['isDesktop']);

    const hour = computed(() => {
      const value = moment(props.value, DATE_TIME_FORMAT);

      if (value.isValid()) {
        return value.hours();
      }
      return 8;
    });

    const minute = computed(() => {
      const value = moment(props.value, DATE_TIME_FORMAT);

      if (value.isValid()) {
        return value.minutes();
      }
      return 0;
    });

    const date = computed(() => {
      const value = moment(props.value, DATE_TIME_FORMAT);

      if (value.isValid()) {
        return value.format(DATE_FORMAT);
      }
      return moment().format(DATE_FORMAT);
    });

    const setDateTime = (dateValue, hourValue, minuteValue) => {
      const dateTimeString = `${dateValue} ${hourValue} ${minuteValue}`;
      const dateTime = moment(dateTimeString, `${DATE_FORMAT} HH mm`).format(DATE_TIME_FORMAT);
      emit('input', dateTime);
    };

    const setHour = (up) => {
      let { value } = hour;

      if (up) {
        value += 1;
      } else {
        value -= 1;
      }

      if (value === 24) {
        value = 0;
      }

      if (value === -1) {
        value = 23;
      }

      setDateTime(date.value, value, minute.value);
    };

    const setMinute = (up) => {
      let minuteValue = minute.value;
      let hourValue = hour.value;

      if (up) {
        minuteValue += 1;
      } else {
        minuteValue -= 1;
      }

      if (minuteValue === 60) {
        minuteValue = 0;
        hourValue += 1;
      }

      if (minuteValue === -1) {
        minuteValue = 59;
        hourValue -= 1;
      }

      if (hourValue === 24) {
        hourValue = 0;
      }

      if (hourValue === -1) {
        hourValue = 23;
      }

      setDateTime(date.value, hourValue, minuteValue);
    };

    const setDate = (val) => {
      setDateTime(val, hour.value, minute.value);
    };

    const dislayDateTime = computed(() => {
      const dateTime = moment(props.value, DATE_TIME_FORMAT);
      if (dateTime.isValid()) {
        return dateTime.format(DISPLAY_DATE_TIME_FORMAT);
      }
      return '';
    });

    return {
      isDesktop,
      hour,
      minute,
      setHour,
      setMinute,
      date,
      setDate,
      dislayDateTime,
      faChevronUp,
      faChevronDown,
      moment,
      DATE_FORMAT,
      DISPLAY_DATE_TIME_FORMAT,
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

.datetime {
  @media (min-width: 992px) {
    width: 500px;
  }

  .clock {
    margin-top: 15px;

    .container {
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }


  .vertical {
    border-left: 2px solid $black;
    height: 100%;
  }

  .grid-container {
    display: grid;
    grid-template-columns: auto auto auto;
    padding: 10px;

    .time-digit {
      font-size: 50px;
    }
  }

  .icon {
    cursor: pointer;
    font-size: 25px;
    color: $grey;
  }
}
</style>
